import React, { useEffect, useState } from 'react';
import { Row, Col, Nav, Tab, Badge } from 'react-bootstrap';
import Layout from '../../wrappers/layout';
import PageHeader from '../../shared/page-header';
import UserInfo from './components/user-info';
import BankDetails from './components/bank-details';
import AccountDetails from './components/account-details';
import Loader from '../../shared/common/loader';
import DashboardHttp from './services/profile.service';
import { userStore } from '../../store/UserStore';
import Toast from '../../shared/common/toast';
import infoIco from 'assets/images/i-circle.svg';
import Documents from './components/documents';
import VirtualAccount from './components/virtual-account';
import Nomination from './components/customerNomination';
import NewAccountDetails from './components/newaccount-details';
import SummaryInfo from './components/summary-reports';

interface PropsType {}

const ProfilePage: React.FC<PropsType> = () => {
  const [loading, setLoading] = useState<any>(false);
  const [selectedTab, setSelectedTab] = useState<string>('userDetails');
  const [user, customer, setUser, setCustomer, customerId, selectedAccount] =
    userStore((state: any) => [
      state.user,
      state.customer,
      state.setUser,
      state.setCustomer,
      state.customerId,
      state.selectedAccount,
    ]);

  useEffect((): any => {
    // removed due to unauthorized issue in B2b
    // getProfile(customerId);
    document.title = 'Profile - eBullion';
    let bankDetails = new URLSearchParams(location.search).get('bank');
    let nomination = new URLSearchParams(location.search).get('nomination');

    if (bankDetails === 'true') {
      setSelectedTab('bankDetails');
    } else if (nomination === 'true') {
      setSelectedTab('nomination');
    }
    // eslint-disable-next-line
  }, []);

  const getProfile = async (customerId: any) => {
    try {
      const userData: any = await DashboardHttp.getProfile(
        customerId,
        user?.userId
      );
      if (userData.status === 200 && userData.data.data) {
        setUser(userData.data.data.user);
        setCustomer(userData.data.data.customer);
        setLoading(false);
      }
    } catch (e: any) {
      console.log(e);
      setLoading(false);
    }
  };

  return (
    <Layout>
      {loading ? (
        <Loader />
      ) : (
        <div>
          {/*<Toast/>*/}
          <PageHeader mainTitle='My Profile' subTitle='' isShowSub={false} />
          <Row>
            <Col md={12}>
              <Tab.Container
                id='left-tabs-example'
                defaultActiveKey={'userDetails'}
                activeKey={selectedTab}
                onSelect={(k) => {
                  setSelectedTab(k);
                }}
              >
                <Row>
                  <Col sm={3}>
                    <Nav variant='pills' className='flex-column'>
                      <Nav.Item>
                        <Nav.Link eventKey='userDetails'>
                          User Details{' '}
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey='bankDetails'>
                          Bank Details{' '}
                          {customer.bankDetails.state === 'VERIFIED' &&
                          customer.bankDetails.accountNo &&
                          customer?.upiDetails?.state === 'VERIFIED' &&
                          customer?.upiDetails?.accountNo ? (
                            ''
                          ) : (
                            <Badge bg='none'>
                              <img src={infoIco} alt='' />
                            </Badge>
                          )}
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey='accountDetails'>
                          Address Details{' '}
                          {customer?.accounts.length === 0 ? (
                            <Badge bg='none'>
                              <img src={infoIco} alt='' />
                            </Badge>
                          ) : (
                            ''
                          )}
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey='vaDetails'>
                          Virtual Account Details
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey='summaryReport'>
                          Account Summary
                        </Nav.Link>
                      </Nav.Item>
                      {customer.customerCategory === 'UNREGISTERED' ? (
                        <Nav.Item>
                          <Nav.Link eventKey='nomination'>Nomination</Nav.Link>
                        </Nav.Item>
                      ) : null}
                      {customer.customerCategory === 'REGISTERED' ? (
                        <Nav.Item>
                          <Nav.Link eventKey='customerDocuments'>
                            Documents{' '}
                            {customer?.accounts.length === 0 ? (
                              <Badge bg='none'>
                                <img src={infoIco} alt='' />
                              </Badge>
                            ) : (
                              ''
                            )}
                          </Nav.Link>
                        </Nav.Item>
                      ) : null}
                    </Nav>
                  </Col>
                  <Col sm={9}>
                    <Tab.Content>
                      <Tab.Pane eventKey='userDetails'>
                        <UserInfo user={user} customer={customer} />
                      </Tab.Pane>
                      <Tab.Pane eventKey='bankDetails'>
                        <BankDetails user={user} customer={customer} />
                      </Tab.Pane>
                      <Tab.Pane eventKey='vaDetails'>
                        {/* <AccountDetails user={user} customer={customer} /> */}
                        <VirtualAccount
                          account={selectedAccount}
                          customerId={customerId}
                        ></VirtualAccount>
                      </Tab.Pane>
                      <Tab.Pane eventKey='accountDetails'>
                        {/* <AccountDetails user={user} customer={customer} /> */}
                        <NewAccountDetails user={user} customer={customer} />
                      </Tab.Pane>
                      {customer.customerCategory === 'UNREGISTERED' ? (
                        <Tab.Pane eventKey='nomination'>
                          <Nomination
                            user={user}
                            customer={customer}
                            customerId={customerId}
                            setCustomer={setCustomer}
                          />
                        </Tab.Pane>
                      ) : null}
                      {customer.customerCategory === 'REGISTERED' ? (
                        <Tab.Pane eventKey='customerDocuments'>
                          <Documents user={user} />
                        </Tab.Pane>
                      ) : null}
                      <Tab.Pane eventKey='summaryReport'>
                        {/* <AccountDetails user={user} customer={customer} /> */}
                        <SummaryInfo />
                      </Tab.Pane>
                    </Tab.Content>
                  </Col>
                </Row>
              </Tab.Container>
            </Col>
          </Row>
        </div>
      )}
    </Layout>
  );
};

export default ProfilePage;
